import { Box, Heading, Inline, Stack } from '@srichaitra/ui';

/**
 * A titled block of the dashboard: a heading on the left, its controls on the
 * right, content below.
 *
 * Every section uses this, which is what makes the two panels line up — the
 * same heading size, the same gap, the controls at the same height. Two panels
 * that each invented their own header is most of what made the page look
 * unconsidered.
 *
 * Controls belong here, in the section header, rather than inside the card with
 * the chart. A filter that sits inside a chart's own frame reads as belonging
 * to that chart alone; up here it is visibly attached to the whole section it
 * actually scopes.
 */
export function Section({ title, actions, children }) {
  return (
    <Box as="section">
      <Stack gap={3}>
        {/* minHeight keeps the two section headers on the same rhythm whether or
            not one of them carries controls. */}
        <Inline justify="space-between" align="center" sx={{ minHeight: 40 }}>
          <Heading level={3}>{title}</Heading>
          {actions ? <Inline gap={2}>{actions}</Inline> : null}
        </Inline>

        <Box>{children}</Box>
      </Stack>
    </Box>
  );
}
